import { Component, Input, Output, EventEmitter } from '@angular/core';

import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-auto-complete-email-t-c-b',
  templateUrl: './auto-complete-email-t-c-b.component.html',
  styleUrls: ['./auto-complete-email-t-c-b.component.css']
})
export class AutoCompleteEmailTCBComponent {

  suggestions: any[] = [];
  selectedIndex: number = -1;
  @Input("model") selectedTags: any[];
  @Input() dropDownList: any[];
  @Input("disable") disabled: any;
  @Input() searchText: any;
  @Input() displayName: any;
  @Input() emailName: any;
  @Input() selectedEmail: any;
  @Output() modelChange = new EventEmitter<any[]>();
  @Output() selectedEmailChange = new EventEmitter<any>();

  constructor(private utilityService: UtilityService) { }

  search() {
    this.searchText = this.searchText.trim();
    //Put search logic here
    if (this.searchText.length > 0) {
      var suggestions = [];
      this.dropDownList.forEach((email: any) => {
        if (email[this.emailName].toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 || email[this.displayName].toLowerCase().indexOf(this.searchText.toLowerCase()) > -1)
          suggestions.push({ DisplayName: email[this.displayName], EmailAddress: email[this.emailName] });
      });
      this.suggestions = suggestions;
      if (this.suggestions.length == 0)
        this.selectedIndex = -1;
      else {
        if (this.selectedIndex == -1 || this.selectedIndex > this.suggestions.length) {
          this.selectedIndex = 0;
        }
      }
    } else
      this.suggestions = [];
  }

  checkKeyDown(event: any) {
    if (event.keyCode === 40) {//down key, increment selectedIndex
      event.preventDefault();
      if (this.selectedIndex + 1 !== this.suggestions.length) {
        this.selectedIndex++;
      }
    }
    else if (event.keyCode === 38) { //up key, decrement selectedIndex
      event.preventDefault();
      if (this.selectedIndex - 1 !== -1) {
        this.selectedIndex--;
      }
    }
    else if (event.keyCode === 13) { //enter pressed
      this.addToInput(this.selectedIndex);
    }
    else if (event.keyCode === 9) { //tab pressed
      this.addToInput(this.selectedIndex);
    }
  }

  addToInput(index: number) {
    if (this.suggestions.length > 0) {
      this.searchText = this.suggestions[index].EmailAddress;
      this.selectedTags.push(this.suggestions[index])
      this.suggestions = [];
    }
  }

  addToSelectedTags(index: number, where: string) {
    if (this.selectedTags.indexOf(this.suggestions[index]) === -1) {
      if (index != -1) {
        this.selectedTags.push(this.suggestions[index]);
        this.searchText = '';
        this.suggestions = [];
        this.selectedEmail = where;
        this.selectedEmailChange.emit(this.selectedEmail);
        this.modelChange.emit(this.selectedTags);
      }
      else {
        if (this.utilityService.validateEmail(this.searchText)) {
          var newItem = { EmailAddress: this.searchText, DisplayName: this.searchText }
          this.selectedTags.push(newItem);
          this.searchText = '';
          this.suggestions = [];
          this.selectedEmail = where;
          this.selectedEmailChange.emit(this.selectedEmail);
          this.modelChange.emit(this.selectedTags);
        }
      }
    }
  }

  removeTag(index: number) {
    this.selectedTags.splice(index, 1);
  }

}
